import { Component, Input } from '@angular/core';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Component({
  selector: 'admin-user-list-view',
  templateUrl: './admin-user-list-view.component.html',
  styleUrl: './admin-user-list-view.component.scss',
  standalone: false,
})
export class AdminUserListViewComponent {
  @Input() users: app.models.AdminUsersListModel[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() deleteUser: any;
  @Input() changeUserStatus: any;
  @Input() redirectUserDetails: any;
  @Input() redirectUserRights: any;

  myUserId;

  public constructor(private _globalService: GlobalService) {
    this.myUserId = this._globalService.user.userId;
  }
}
